"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRefresh = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconRefresh = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.566 20.115c-2.294 0-4.251-.81-5.87-2.43-1.62-1.62-2.43-3.576-2.43-5.869 0-2.293.81-4.267 2.43-5.92 1.619-1.655 3.576-2.481 5.87-2.481 1.185 0 2.308.264 3.369.792a9.144 9.144 0 0 1 2.754 2.088v-2.88h2.15v7.465h-7.466V8.73h4.45a6.212 6.212 0 0 0-2.23-2.207 5.912 5.912 0 0 0-3.027-.808c-1.717 0-3.171.591-4.363 1.775-1.192 1.183-1.787 2.625-1.787 4.325 0 1.716.595 3.17 1.787 4.362 1.192 1.192 2.646 1.788 4.363 1.788 1.3 0 2.479-.371 3.537-1.113 1.059-.742 1.796-1.737 2.213-2.987h2.23c-.47 1.832-1.443 3.331-2.919 4.499-1.475 1.167-3.163 1.75-5.061 1.75Z"
}));
exports.IconRefresh = IconRefresh;
//# sourceMappingURL=IconRefresh.js.map